import React, {useEffect, useState, useMemo} from 'react';
import {connect} from "react-redux";
import {Trans, useTranslation} from 'react-i18next';
import {
	isLoadingCommentToAdd, addComment, commentContentToAdd, parseContactOnCommentToAdd, showUpgradeToBusinessToComment
} from '../../../../../../../../../../../actions/commentActions';
import {
    commentToAddContactSearchResult,
    resetCommentToAddContactSearchResult,
    setDetailsForContactCard
} from "../../../../../../../../../../../actions/contactActions";
import { getSharingDetailsPopup } from "../../../../../../../../../../../actions/sharingDetailsActions";
import Button from "../../../../../../../../../../components/button";
import Icon from "../../../../../../../../../../components/icon";
import CommentToAddAutoComplete from "./components/comment-to-add-autocomplete";
import Comment from "./components/comment";
import Loader from "../../../../../../../../../../components/sprite/components/loader";
import {msgCommentBar} from '../../../../../../../../../../../actions/msgBarActions';
import {API_ROOT, translate} from '../../../../../../../../../../utils';
import {postEngagement} from '../../../../../../../../../../../actions/engagementActions';
import {videoPopup} from "../../../../../../../../../../../actions/popupActions";
import './index.css';

function CommentsList (props) {

    const [privateComment, setPrivateComment] = useState(false);
    const [commentBtnClicked, setCommentBtnClicked] = useState(false);
    const [video, setVideo] = useState({
        id: 'jqNnTgyrLRs',
        preview: API_ROOT + '/img/comments-notifications-en.jpg'
    });

    const { t } = useTranslation();

    const {
        sharingDetailsPopup,
        setSharingDetailsPopup,
        resetCommentToAddContactSearchResult,
        addComment,
        findComments,
        findContactDetails,
        selectedContactsGroup,
        editingComment,
        isLoadingCommentToAdd,
        setMsgCommentBar,
        setIsLoadingCommentToAdd,
        commentContentToAdd,
        parseContactOnCommentToAdd,
        commentToAddContactSearchResult,
        setCommentContentToAdd,
        setParseContactOnCommentToAdd,
        setCommentToAddContactSearchResult,
        setDetailsForContactCard,
        getContactCardDetails,
	    hasTheBusinessPermission,
	    showUpgradeToBusinessToComment,
	    setShowUpgradeToBusinessToComment,
	    postEngagement,
        contactDetails,
        videoPopup,
        language
    } = props;

    useEffect(() => {
        if(parseContactOnCommentToAdd){
            setCommentToAddContactSearchResult(parseContactOnCommentToAdd[parseContactOnCommentToAdd.length - 1].substring(1));
        }
    }, [parseContactOnCommentToAdd, setCommentToAddContactSearchResult]);

    useEffect(() => {
        switch (language) {
            case 'fr' :
                setVideo({
                    id: 'RlR4bOkahBg',
                    preview: API_ROOT + '/img/comments-notifications-fr.jpg'
                });
                break;
            case 'es' :
                setVideo({
                    id: 'D73GSKxELKE',
                    preview: API_ROOT + '/img/comments-notifications-es.jpg'
                });
                break;
            default :
                setVideo({
                    id: 'jqNnTgyrLRs',
                    preview: API_ROOT + '/img/comments-notifications-en.jpg'
                });
                break;
        }
    }, [language]);

    const cancelNewCommentHandler = () => {
       let setGmailAddonIncludesGmail = props.sharingDetailsPopup[1].includes('gmail')
       if(setGmailAddonIncludesGmail){
        window.close()
       } else {
        resetCommentToAddContactSearchResult();
        setCommentContentToAdd("");
        setSharingDetailsPopup([]);
        setDetailsForContactCard({});
       }
    };

    const addNewCommentHandler = (e) => {

        if(hasTheBusinessPermission){
	        e.preventDefault();

	        setCommentBtnClicked(true);

	        if(e.currentTarget.dataset.disabled === "true"){

		        e.currentTarget.style.cursor = 'not-allowed';
		        setMsgCommentBar(['error', translate('textCommentError')]);

	        } else {
		        setIsLoadingCommentToAdd(true);

		        let mentionsArray = commentContentToAdd.match(/@\w+\.?\w+@\w+\.\w+/g);
		        let mentionsArrayWithoutAt = [];

		        if(mentionsArray){
			        mentionsArrayWithoutAt = mentionsArray.map( item => (
				        item.substring(1)
			        ));
		        }

		        let selectedLabelId;

		        if(selectedContactsGroup.type === "system"){
			        selectedLabelId = 6
		        } else {
			        selectedLabelId = selectedContactsGroup.id
		        }

                if(sharingDetailsPopup.length > 0){
                    addComment(sharingDetailsPopup[2][0].id, selectedLabelId, {
                        "comment" : document.getElementById('writeNewComment').value,
                        "permission" : privateComment ? "PRIVATE" : "PUBLIC",
                        "mentions": mentionsArrayWithoutAt
                    });
                } else {
                    addComment(contactDetails.id, selectedLabelId, {
                        "comment" : document.getElementById('writeNewComment').value,
                        "permission" : privateComment ? "PRIVATE" : "PUBLIC",
                        "mentions": mentionsArrayWithoutAt
                    });
                }

	        }
        } else {
		    setShowUpgradeToBusinessToComment(true);
	    }

	};

    const privateCommentHandler = () => {
        setPrivateComment(!privateComment);
    };

    const changeHandler = (e) => {
        setCommentContentToAdd(e.currentTarget.value);
        setParseContactOnCommentToAdd(e.currentTarget.value.match(/@\w+$/g));
    };

    const commentResponses = useMemo(()=>{
        let newCommentArray = findComments?.commentResponses;
           if(!Array.isArray(newCommentArray)){
            return newCommentArray
           }
           let indexOfCommentId =  getContactCardDetails && Array.isArray(newCommentArray) && newCommentArray?.findIndex((comment)=>comment.commentId === getContactCardDetails?.commentId)
           if(indexOfCommentId > -1){
              const removedItem =  newCommentArray?.splice(indexOfCommentId,1);
              newCommentArray = [...removedItem,...newCommentArray]
           }
           return newCommentArray
    },[findComments,getContactCardDetails]);

    const handleClose = () => {
	    setShowUpgradeToBusinessToComment(false);
    };

	const handleUpgradeToBusiness = () => {
		postEngagement(59, new Intl.DateTimeFormat('fr-FR', {
			day: '2-digit',
			month: '2-digit',
			year: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
			second: '2-digit',
		}).format());
	};

    const handlePlay = () => {
        if(sharingDetailsPopup.length > 0){
            setSharingDetailsPopup([]);
            setTimeout(() => {
                videoPopup(video.id);
            }, 250)
        } else {
            videoPopup(video.id);
        }
    };

    return (
        <div className={`comments-list-wrapper${showUpgradeToBusinessToComment ? ' upgrade-to-business-to-comment' : ''}`}>
            {
	            !hasTheBusinessPermission && <div className="upgrade-to-business-to-comment__popup">
		            <Button className="float-right p-0 ml-2 mb-2" onClick={handleClose}>
			            <svg width="34" height="34" viewBox="0 0 34 34" fill="none"
			                 xmlns="http://www.w3.org/2000/svg">
				            <path fillRule="evenodd" clipRule="evenodd"
				                  d="M34 17C34 26.3888 26.3888 34 17 34C7.61116 34 0 26.3888 0 17C0 7.61116 7.61116 0 17 0C26.3888 0 34 7.61116 34 17ZM8.38383 25.6162C7.79804 25.0304 7.79804 24.0807 8.38383 23.4949L14.8787 17L8.38374 10.5051C7.79795 9.91932 7.79795 8.96957 8.38374 8.38378C8.96952 7.798 9.91927 7.798 10.5051 8.38378L17 14.8787L23.4949 8.38378C24.0807 7.798 25.0305 7.798 25.6163 8.38378C26.202 8.96957 26.202 9.91932 25.6163 10.5051L19.1213 17L25.6162 23.4949C26.202 24.0807 26.202 25.0304 25.6162 25.6162C25.0304 26.202 24.0806 26.202 23.4949 25.6162L17 19.1214L10.5052 25.6162C9.91936 26.202 8.96962 26.202 8.38383 25.6162Z"
				                  fill="#FF1938"/>
			            </svg>
		            </Button>

		            <p>{t('upgradeToBusinessToCommentText')}</p>
		            <Button onClick={handleUpgradeToBusiness} className="btn-primary">{t('upgradeToBusinessBtn')}</Button>
	            </div>
            }

            <div className={`comments-list${ editingComment ? ' is-editing-comment' : ''}`}>
                <div className="comments">
                    {
                        findComments
                        ?
                        Array.isArray(commentResponses)  && commentResponses.length > 0
                            ?

                            commentResponses.slice(0).reverse().map((comment) => (
                                <Comment
                                    key={comment.commentId}
                                    commentId={comment.commentId}
                                    commentPrivacy={comment.permission}
                                    authorName={comment.authorName}
                                    avatar={comment.pictureUrl}
                                    content={comment.comment}
                                    timestamp={comment.timestamp}
                                    updatedTimestamp={comment.updatedTimestamp}
                                    editingComment={editingComment}
                                    permission={comment.permission}
                                    aiComment={comment.aiComment}
                                />
                            ))
                            :
                            <div className="text-center mb-3">
                                <p className="mb-4 font-italic">
                                    <Trans i18nKey="commentsListNoCommentSaySomething" values={{name: findContactDetails.name}} />
                                </p>
                                <button className="video-button" onClick={handlePlay}>
                                    <Icon name="play-circle"/>
                                    <img data-video={video.id} className="d-block" src={video.preview} width="300"
                                         alt=""/>
                                </button>
                            </div>
                            :
                            <Loader/>
                    }
                </div>
                {
                    editingComment === null
                    &&
                    <>
                        <div className="new-comment-area">

                            <textarea
                                className="form-control mr-0"
                                name="write_new_comment"
                                id="writeNewComment"
                                rows="1"
                                placeholder={t("fieldAddComment")}
                                onChange={changeHandler}
                            />

                            { parseContactOnCommentToAdd && commentToAddContactSearchResult.length > 0 && <CommentToAddAutoComplete/> }

                        </div>
                        <div className="d-flex align-items-center justify-content-between w-100 options">
                            <div className="custom-control custom-checkbox mr-sm-2">
                                <input onChange={privateCommentHandler} disabled={findContactDetails.editable === false} className="custom-control-input" type="checkbox" name="privateComment" id="privateComment"/>
                                <label htmlFor="privateComment" className="custom-control-label">{t("fieldPrivateComment")}</label>
                                <p>{privateComment}</p>
                            </div>
                            {
                                isLoadingCommentToAdd
                                    ?
                                    <div className="text-right">
                                        <Button className="btn-primary font-weight-bold" disabled={true}>
                                            <Icon animated={'pulse'} name="spinner"/>
                                        </Button>
                                    </div>
                                    :
                                    <div className="text-right">
	                                    {
		                                    sharingDetailsPopup.length > 0 && <Button className="btn-outline-primary" onClick={cancelNewCommentHandler}>{t("textCancel")}</Button>
	                                    }
                                        <Button
                                            className="btn-primary ml-2"
                                            data-disabled={
                                                selectedContactsGroup === null ||
                                                commentContentToAdd.length === 0 ||
                                                (commentBtnClicked && findContactDetails.commentable === false && !privateComment)
                                            }
                                            aria-disabled={
                                                selectedContactsGroup === null ||
                                                commentContentToAdd.length === 0 ||
                                                (commentBtnClicked && findContactDetails.commentable === false && !privateComment)
                                            }
                                            onClick={addNewCommentHandler}
                                            disabled={
                                                selectedContactsGroup === null ||
                                                commentContentToAdd.length === 0 ||
                                                (commentBtnClicked && findContactDetails.commentable === false && !privateComment)
                                            }
                                        >
                                            {t("textComment")}
                                        </Button>
                                    </div>
                            }
                        </div>
                    </>
                }
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        findComments: state.commentReducer.findComments,
        findContactDetails: state.contactDetailsReducer.findContactDetails,
        sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup,
        selectedContactsGroup: state.contactsGroupItemReducer.getSelectedContactsGroup,
        editingComment: state.commentReducer.editingComment,
        isLoadingCommentToAdd: state.commentReducer.isLoadingCommentToAdd,
        commentContentToAdd: state.commentReducer.commentContentToAdd,
        parseContactOnCommentToAdd: state.commentReducer.parseContactOnCommentToAdd,
        commentToAddContactSearchResult: state.contactReducer.commentToAddContactSearchResult,
        getContactCardDetails: state.contactReducer.contactCardDetails,
	    hasTheBusinessPermission: state.permissionReducer.hasTheBusinessPermission,
	    showUpgradeToBusinessToComment: state.commentReducer.showUpgradeToBusinessToComment,
        language: state.languageReducer.language
    }
};

const mapDispatchToProps = (dispatch) => ({
    setIsLoadingCommentToAdd: (boolean) => dispatch(isLoadingCommentToAdd(boolean)),
    addComment: (contactId, labelId, msgObj) => dispatch(addComment(contactId, labelId, msgObj)),
    setParseContactOnCommentToAdd: (array) => dispatch(parseContactOnCommentToAdd(array)),
    setCommentContentToAdd: (string) => dispatch(commentContentToAdd(string)),
    setCommentToAddContactSearchResult: (string) => dispatch(commentToAddContactSearchResult(string)),
    resetCommentToAddContactSearchResult: () => dispatch(resetCommentToAddContactSearchResult()),
    setSharingDetailsPopup: (array) => dispatch(getSharingDetailsPopup(array)),
    setMsgCommentBar: (boolean) => dispatch(msgCommentBar(boolean)),
    setDetailsForContactCard: (object) => dispatch(setDetailsForContactCard(object)),
	setShowUpgradeToBusinessToComment: (boolean) => dispatch(showUpgradeToBusinessToComment(boolean)),
	postEngagement: (id, value) => dispatch(postEngagement(id, value)),
    videoPopup: (id) => dispatch(videoPopup(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(CommentsList);
